export default "__VITE_ASSET__HRI0DYCe__"